import React from 'react';
import './InfoAgents.scss';
import Spinner from 'Components/Shared/Spinner/Spinner';
import AgentItem from 'Components/InfoAgents/AgentItem/AgentItem';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  isFetching: boolean;
  isFetchFailed: boolean;
  agents: Julius.Website.AgentViewModel[];
  content: Julius.Website.AgentsPageViewModel;
}

const InfoAgents: React.SFC<IProps> = ({
  isFetching,
  isFetchFailed,
  agents,
  content,
}) => {

  if (isFetching) {
    return (
      <WrapperLayout style='info-agents'>
        <Spinner height='lg' />
      </WrapperLayout>
    );
  }

  if (isFetchFailed || !content || !agents) {
    return null;
  }

  return (
    <WrapperLayout style='info-agents'>
      <div>
        <div className='agents-title'>{ content.title }</div>
        <div className='agents-text' dangerouslySetInnerHTML={ { __html: content.text } } />
      </div>
      <div className='agents-list'>
        { agents.map((agent, key) => <AgentItem { ... { key, agent } }/>) }
      </div>
    </WrapperLayout>
  );
};

export default InfoAgents;


// WEBPACK FOOTER //
// ./src/components/InfoAgents/InfoAgents.tsx